import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="5 Must-Know Tips for Working from Home article by Kat Medina, author of the book, The Joys of Jet Lag. Tips for productively working remotely during the COVID-19 coronavirus outbreak." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'So, you just got the thumbs up to work from home from your employer because of the quickly spreading coronavirus? Congratulations on being one step closer to productively contributing to society from the comforts of your couch. #livingthedream. Be warned, though, it’s not all slippers and sweatpants. If you’re new to remote working, there are some key things you must do to make sure you don’t end up turning into a lonely, hygienically challenged sofa spud fueled by Mountain Dew.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I’ve been working remotely the last nine years and have picked up a few tips and tricks over the years that will help you as you make this temporary transition. Without the time-sucking impromptu meetings and distracting visits from Chatty Cathy and Coffee-breath Carl at your cubicle, you have the potential to be even more productive at home than in the office.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Rule #1: Clean yourself'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'For the sake of your spouse/kids/dog/self-respect, don’t give in to the temptation of just rolling out of bed and going right to your laptop. Taking a whore’s bath is not the same thing as an actual shower. Get up, make your bed, brush your teeth, shower and put on your deodorant. Then and only then do you have permission to put on some daytime jammies. This brings me to my next rule...'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Rule #2: Get comfortable'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'One of the best parts about working from home is the encouragement of sporting elastic waistbands and fuzzy slippers as you crush deals and spreadsheet your little heart out. If you have a video meeting, business casual takes on a different meaning. Sweats on the bottom, button-down on the top. It’s like a work attire mullet and it is absolutely glorious. Just be careful not to stand up on the call and reveal the party on the bottom. Especially if you are one of those freakaleaks that is braving business commando.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Rule #3: Eat well'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Go grocery shopping and make a meal plan for your breakfasts, lunches, and snacks. If you don’t prepare for the inevitable calling-of-cookies from your easily accessible kitchen at around 10 AM and 2 PM, you will find yourself downing a whole sleeve of Oreos in a bowl with milk and justifying it by calling it cereal. Learn from my mistakes. Prep your lunches. Eating well will prevent any crappy food-induced crashes that might tempt you to take a little nappy nap.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Rule #4: Move around'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Have your running shoes easily accessible so that if you start to lose motivation you can slip them on and head outside for an energy-boosting 10-minute walk. Take advantage of the fact that you can take these micro-breaks. Breaking up your workday with brief walks has been proven to increase productivity. Might as well put that activewear you are sporting to use, right?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Rule #5: Connect with others'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Most people underestimate the loneliness that can creep its way into your workspace similarly to the suffocating, putrid air that fills the room after your coworker, Glen, reheats his fish and broccoli leftovers in the microwave. It’s subtle at first, then quickly and undeniably consumes every part of your being.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'People often try to fight the loneliness by going on social media, but this just makes it worse. Trust me. Don’t waste time trying to grasp a sense of connection from an app that systematically does the opposite. Instead, on one of your brief walks, give your bestie a call. Text your bros. Go on your team’s slack channel and shoot the shit. Make plans after work to FaceTime with some friends and enjoy some Coronas in honor of COVID-19’s effect on the freedom from your soul-crushing grey cubicle.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Prepare yourself for your time at home and make the most of it. You’ve been given one hell of a gift and productivity comes from solid preparation. There are few greater things than getting paid to work in sweatpants while blasting your screamo metal music directly from your speakers instead of trying to stifle it in your headphones.'}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/workfromhome.js